import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { cerrarSesion } from "../../redux/actions/session"
import { urlapi } from "../../lib/backend/data"
import { Button, ButtonGroup, Card, Col, Row } from "react-bootstrap"
import { estilo_last_mile } from "../../lib/global/styles"
import { gps_integrados } from "../../lib/global/data"

const FuentesDato = (props) => {
    let fuentes_default = [{ value: "", label: "Móvil", selected: true }]
    const [ fuenteSeleccionada, setFuenteSeleccionada ] = useState('')
    const [ fuentes, setFuentes ] = useState(fuentes_default)
    const [ loading, setLoading ] = useState(true)
    const GPS = {}
    gps_integrados.map(e => GPS[e.slug] = e.logo)
    const dispatch = useDispatch()
    const sesion = useSelector(state => state.miusuario)

    useEffect(() => {
        refrescarListado()
    }, [])

    const refrescarListado = async () => {
    
        return fetch(`${urlapi}/configuracion/tipo?tipo=gps-integracion`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                return false
            } else if(res.errorMessage){
                return false
            } else if(Array.isArray(res) !== false){
                setFuentes([...fuentes_default, ...res.map(e => ({ value: e.sub_tipo, label: e.sub_tipo }))])
            }
            return setLoading(false)
        })
        .catch(error => {
            return setLoading(false)
        })
    }

    const seleccionar = (i) => {
        setFuentes(prev => {
            let actual = [...prev]
            const iterar = actual.map((e,pos) => {
                e.selected = pos === i ? true : false

                if(pos === i){
                    props.onChange(e.value)
                }
                return e
            })

            return [...[], ...iterar]
        })
    }

    return <div>
        <ButtonGroup>
            {
                fuentes.map((fue,i) => {
                    return <Button size="sm" variant={fue.selected ? "primary" : "light"} md={3} xs={12} key={`r-${i}`} style={{ textTransform: "uppercase", fontWeight: "bold" }} onClick={() => seleccionar(i)} className="mb-3">{GPS[fue.label] ? <img src={GPS[fue.label]}  style={{ height: 20 }} />  : fue.label}</Button>
                })
            }
        </ButtonGroup>
    </div>

}

export default FuentesDato